import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

// レスポンス構造
type GetCycleDispConditionResponse = {
  DispMedium: string;
  DispBuyer: string;
  DispCoop: string;
  DispDiv: string;
  StartOrderCode: string;
  EndOrderCode: string;
};

/**
 * サイクル設定表示条件取得サービス
 * @export GetCycleDispConditionService
 * @class GetCycleDispConditionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCycleDispConditionService extends PlessJsonResponderSub<GetCycleDispConditionResponse> {
  model: KYMW1200Model;
  private succeed: () => void;
  private fail: () => void;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCycleDispConditionService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetCycleDispConditionService
   */
  execute(
    model: KYMW1200Model,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.succeed = s;
    this.fail = f;
    this.send('getCycleDispCondition', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCycleDispConditionService
   */
  success(data: GetCycleDispConditionResponse) {
    if (data) {
      this.model.mediumType = data.DispMedium;
      // 表示バイヤー
      if (!PlessViewUtilsSub.isEmpty(data.DispBuyer)) {
        this.model.buyerCode = data.DispBuyer;
      } else {
        // レスポンスに表示バイヤーがない場合、ログインユーザに紐づくバイヤーコード（うち、最も若い番号）を表示
        this.model.buyerCode = this.minLoginBuyerCode();
      }
      this.model.coopCode = data.DispCoop;
      this.model.switchType = data.DispDiv;
      this.model.orderCodeFrom = data.StartOrderCode;
      this.model.orderCodeTo = data.EndOrderCode;
    } else {
      // レスポンスに表示バイヤーがない場合、ログインユーザに紐づくバイヤーコード（うち、最も若い番号）を表示
      this.model.buyerCode = this.minLoginBuyerCode();
    }
    if (this.succeed) this.succeed();
    if (this.successFunc) this.successFunc(data);
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model, successFunc: Function): Promise<void> {
    this.successFunc = successFunc;
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }

  /**
   * ログインユーザに紐づくバイヤーコードのうち最も若い番号を返却するメソッド
   * 取得した表示バイヤー（DispBuyer）がない場合に使用
   * @returns string
   */
  private minLoginBuyerCode(): string {
    const loginBuyerCodeList = this.model.userBuyerCodeList;
    let loginBuyerCode = '';
    if (PlessViewUtilsSub.isEmptyArray(loginBuyerCodeList)) {
      // ログインユーザに紐づくバイヤーコードがない場合、空を返却
      loginBuyerCode = '';
    } else {
      // バイヤーコードを数値として配列に格納
      const buyerCodeNumberList = loginBuyerCodeList.map(_ => Number(_));
      // 数値化したバイヤーコードのうち、最小値のインデックス番号を取得
      const minIndex = buyerCodeNumberList.indexOf(Math.min(...buyerCodeNumberList));
      // 最小値のバイヤーコードの文字列を格納
      loginBuyerCode = loginBuyerCodeList[minIndex];
    }
    return loginBuyerCode;
  }
}
